import { useQuery } from '@tanstack/react-query';
import QUERY_KEYS from 'services/api/queryKeys';
import { getEInvoiceStatus } from 'services/api/module/report.api';
import get from 'lodash/get';
import { EInvoiceStatusType } from '@/services/api/type/report.type';

export const useGetEInvoiceStatus = (date?: string) => {
  const { data, isFetching, isFetched } = useQuery({
    queryKey: [QUERY_KEYS.GET_E_INVOICE_STATUS, date],
    queryFn: () => {
      if (!date) {
        return;
      }
      return getEInvoiceStatus(date);
    }
  });

  return {
    data: get(data, 'data', []) as EInvoiceStatusType[],
    isFetching,
    isFetched
  };
};
